import { ROLES } from '../constants';

/**
 * Hub Portal roles from /app/users/me response:
 * - 100: CompliSpace Administrator
 * - 200: Group Administrator
 * - 300: Client Administrator
 * - 400: Client User
 *
 * PolicyConnect internal roles (from constants.js):
 * - 4: CS_ADMIN
 * - 3: GROUP_ADMIN
 * - 2: CLIENT_ADMIN
 * - 1: CLIENT_USER
 * - 0: NOT_AUTHENTICATED
 */

const HUB_ROLES = {
  COMPLISPACE_ADMIN: 100,
  GROUP_ADMIN: 200,
  CLIENT_ADMIN: 300,
  CLIENT_USER: 400
};

const defaultZeroHandler = {
  get(obj, prop) {
    return prop in obj ? obj[prop] : ROLES.NOT_AUTHENTICATED;
  }
};

const hubRoleMap = new Proxy(
  {
    [HUB_ROLES.COMPLISPACE_ADMIN]: ROLES.CS_ADMIN, // 100 → 4
    [HUB_ROLES.GROUP_ADMIN]: ROLES.GROUP_ADMIN, // 200 → 3
    [HUB_ROLES.CLIENT_ADMIN]: ROLES.CLIENT_ADMIN, // 300 → 2
    [HUB_ROLES.CLIENT_USER]: ROLES.CLIENT_USER // 400 → 1
  },
  defaultZeroHandler
);

/**
 * Converts Hub bestRole to PolicyConnect internal role level
 * @param {number} hubBestRole - The bestRole from /app/users/me (100, 200, 300, or 400)
 * @returns {number} Internal role level (4, 3, 2, 1, or 0 if invalid)
 */
function mapHubRoleToInternal(hubBestRole) {
  const internalRole = hubRoleMap[hubBestRole];

  if (internalRole === ROLES.NOT_AUTHENTICATED) {
    console.warn(`Unknown Hub role: ${hubBestRole}, defaulting to NOT_AUTHENTICATED`);
  }

  return internalRole;
}

export { mapHubRoleToInternal, HUB_ROLES };
